










































































































































































































































import CommentItem from './components/comment_item.vue'
import {
  apiEvaluationEvaluateList,
  apiEvaluationEvaluateSubmitStrategyEvaluate,
  apiMallDocInfoResourceGet,
  apiMallDocInfoStrategyDetails,
  apiMallDocInfoStrategyLikeOrUnLike,
} from '@/api'
import { computed, ref } from '@vue/composition-api'
import {
  defineClassComponent,
  useApi,
  useLeavePageConfirm,
  useQuery,
} from '@/hooks'
import { keyBy, truncate } from 'vtils'
import { prepareData, submit, Track } from '@/utils'
import { useWaterfall } from '@/components'

const flag1 = 'Fc8J7lZulYZ8D8hqQ5UX6'
const flag2 = 'MM_qD6k_PO7GbXxzDShJX'

export default defineClassComponent(
  {
    components: {
      CommentItem,
    },
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '攻略详情页',
        }))

        useLeavePageConfirm(
          () => !this.commentContent.value,
          '有未发布的评论内容，退出将不会保存任何内容，确认退出么？',
        )
      }

      loading = computed(() => this.apiData.loading)

      query = useQuery<{
        id: string
      }>()

      shareParams = computed(() => ({
        title: this.strategyData.value.title,
        desc: `作者：${this.strategyData.value.author}，${truncate(
          this.strategyData.value.content.replace(/<[^>]+>/g, ''),
          {
            length: 30,
          },
        )}`,
        cover: this.strategyData.value.headPic[0],
      }))

      apiData = useApi(() =>
        prepareData({
          strategyData: apiMallDocInfoStrategyDetails({
            id: this.query.id,
          }).then(async res => {
            await new Promise<void>(resolve => {
              const img = new Image()
              img.onload = () => {
                const ratio = window.innerWidth / img.naturalWidth
                const height = ratio * img.naturalHeight
                // @ts-ignore
                res.bannerHeight = height
                resolve()
              }
              img.src = res.headPic[0]
            })

            const resourceIdList = [
              ...res.content.matchAll(/resource_list=([\w,]+)/g),
            ]
              .map(item => item[1].split(',').filter(Boolean))
              .flat()
            const resourceList = resourceIdList.length
              ? await apiMallDocInfoResourceGet({
                  id: resourceIdList,
                })
              : []
            const resourceMap = keyBy(resourceList, item => item.id)

            const content = res.content.replace(
              /(?:<p>)?\s*<img[^>]+?resource_list=([\w,]+)[^>]+?>\s*(?:<\/p>)?/g,
              ($0, $1: string) => {
                const resources = $1
                  .split(',')
                  .filter(Boolean)
                  .map(id => resourceMap[id])
                  .filter(Boolean)
                return `${flag1}${flag2}resourceList(${JSON.stringify(
                  resources,
                )})${flag1}`
              },
            )
            const contentArr = content
              .split(flag1)
              .filter(Boolean)
              .map(item => {
                if (item.startsWith(flag2)) {
                  const [, type, data] = item
                    .substring(flag2.length)
                    .match(/^(\w+)\((.+)\)$/)!
                  return {
                    type: type,
                    data: JSON.parse(data),
                  }
                }
                return {
                  type: 'html',
                  data: item,
                }
              })

            return { ...res, contentArr }
          }),
        }),
      )

      strategyData = computed(() => this.apiData.data.strategyData)

      bannerIndex = ref(0)

      handleBannerChange = (index: number) => {
        this.bannerIndex.value = index
      }

      goodsIndex = ref(0)

      handleGoodsChange = (index: number) => {
        this.goodsIndex.value = index
      }

      showCommentDialog = ref(false)

      commentContent = ref('')

      handleCommentSendClick = () => {
        submit(async $ => {
          if (!this.commentContent.value) {
            return $.fail('请输入评论内容')
          }
          $.start()
          await apiEvaluationEvaluateSubmitStrategyEvaluate({
            commodityServiceId: this.query.id,
            commodityServiceName: this.strategyData.value.title,
            evaluateContent: this.commentContent.value,
            parentEvaluateId: undefined as any,
          })
          await this.apiData.refresh()
          await this.waterfall.reload()
          await $.success('评论成功，待审核通过后展示')
          this.commentContent.value = ''
          this.showCommentDialog.value = false
        })
      }

      handleLikeClick = () => {
        submit(async $ => {
          $.start()
          await apiMallDocInfoStrategyLikeOrUnLike({
            id: this.query.id,
          })
          await this.apiData.refresh()
        })
      }

      waterfall = useWaterfall('waterfall')

      handleCommentLoad = async ({ pageNumber }: any) => {
        return apiEvaluationEvaluateList({
          commodityServiceId: this.query.id,
          havingPicFlag: 0,
          pageIndex: pageNumber,
          pageSize: 10,
        })
      }
    },
)
